/* Ayudate · Contacto público */

/* Correo público general: la casilla compartida de soporte, nunca una
   cuenta personal. Poniéndolo en null esa fila deja de mostrarse en el
   pie y en la franja de contacto. */
export const CONTACTO = {
  whatsapp: "50661401817",
  whatsappVisible: "6140 1817",
  correo: "soporte@ayudatetutorias.com",
};
